import React from 'react';
import CorrugatedCardboardMaterialsSection from 'components/quote_builder_widget/CorrugatedCardboardMaterialsSection';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const CorrugatedMaterialsSectionWrapper = ({
  onMaterialsChange,
}) => {
  return (
    <div>
      <h4 className={styles.sectionHeader}>
        {t('quote_builder_widget.section_corrugated_materials')}
      </h4>

      <div className={styles.fieldGroup}>
        <label className={styles.label}>
          {t('quote_builder_widget.corrugated_unit_prices') || 'Unit Prices'}
        </label>
        <p className={styles.helpText}>
          {t('quote_builder_widget.corrugated_unit_prices_info') || 'Select which unit prices are available in the widget for corrugated cardboard drawings.'}
        </p>

        <CorrugatedCardboardMaterialsSection onMaterialsChange={onMaterialsChange} />
      </div>
    </div>
  );
};

export default CorrugatedMaterialsSectionWrapper;
